var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.78125C7.01319 3.78125 3.78125 7.01319 3.78125 11C3.78125 14.9868 7.01319 18.2188 11 18.2188C14.9868 18.2188 18.2188 14.9868 18.2188 11C18.2188 7.01319 14.9868 3.78125 11 3.78125ZM1.71875 11C1.71875 5.87411 5.87411 1.71875 11 1.71875C16.1259 1.71875 20.2812 5.87411 20.2812 11C20.2812 16.1259 16.1259 20.2812 11 20.2812C5.87411 20.2812 1.71875 16.1259 1.71875 11Z",
    fill: "#F5222D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.84375C11.5695 5.84375 12.0312 6.30546 12.0312 6.875V11.3438C12.0312 11.9133 11.5695 12.375 11 12.375C10.4305 12.375 9.96875 11.9133 9.96875 11.3438V6.875C9.96875 6.30546 10.4305 5.84375 11 5.84375Z",
    fill: "#F5222D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.1562C11.7594 16.1562 12.375 15.5406 12.375 14.7812C12.375 14.0219 11.7594 13.4062 11 13.4062C10.2406 13.4062 9.625 14.0219 9.625 14.7812C9.625 15.5406 10.2406 16.1562 11 16.1562Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleRed);
export default __webpack_public_path__ + "static/media/warning-circle-red.a96117ea.svg";
export { ForwardRef as ReactComponent };